import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.editor.live_hint_side": "Chapda darhol ko'rinadi",
    "tk.editor.live_hint_top": "Taklifnoma yuqorida darhol yangilanadi",
    "tk.editor.preview_open": "Yangi oynada ochish",
    "tk.editor.preview_caption": "Mehmonlaringiz taklifnomani aynan shunday ko'radi",
    "tk.editor.next_step": "Keyingi qadam",
    "tk.editor.list.add_row": "qator qo'shish",
    "tk.editor.list.optional": "ixtiyoriy — agar qoldirsangiz, taklifnomada ko'rinmaydi",
    "tk.editor.list.remove": "o'chirish",
    "tk.editor.list.remove_aria": "#{n}-qatorni o'chirish",
    "tk.editor.select_placeholder": "— tanlang —",
    "tk.editor.upload_failed": "Yuklab bo'lmadi",
  },
  ru: {
    "tk.editor.live_hint_side": "Изменения сразу видны слева",
    "tk.editor.live_hint_top": "Приглашение выше обновляется сразу",
    "tk.editor.preview_open": "Открыть в новой вкладке",
    "tk.editor.preview_caption": "Именно так гости увидят ваше приглашение",
    "tk.editor.next_step": "Следующий шаг",
    "tk.editor.list.add_row": "добавить строку",
    "tk.editor.list.optional": "необязательно — если оставить пустым, в приглашении не появится",
    "tk.editor.list.remove": "удалить",
    "tk.editor.list.remove_aria": "Удалить строку #{n}",
    "tk.editor.select_placeholder": "— выберите —",
    "tk.editor.upload_failed": "Не удалось загрузить",
  },
  en: {
    "tk.editor.live_hint_side": "Changes appear on the left instantly",
    "tk.editor.live_hint_top": "The invitation above updates instantly",
    "tk.editor.preview_open": "Open in a new tab",
    "tk.editor.preview_caption": "This is exactly how your guests will see it",
    "tk.editor.next_step": "Next step",
    "tk.editor.list.add_row": "add a row",
    "tk.editor.list.optional": "optional — if left empty, it won't appear on the invitation",
    "tk.editor.list.remove": "remove",
    "tk.editor.list.remove_aria": "Remove row #{n}",
    "tk.editor.select_placeholder": "— select —",
    "tk.editor.upload_failed": "Upload failed",
  },
};

export default dict;
